import { NgModule } from '@angular/core';
import { FormattedAmountDirective } from './formatted-amount.directive';
import { HeightGeneratorDirective } from './height-generator.directive';

const DIRECTIVES = [FormattedAmountDirective, HeightGeneratorDirective];

@NgModule({
  declarations: [...DIRECTIVES],
  imports: [],
  exports: [...DIRECTIVES],
})
export class DirectivesModule {}
